"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * Set an attendee network health
 */
function setAttendeeNetworkHealth(networkHealthData) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_ATTENDEE_NETWORK_HEALTH, networkHealthData);
}
var _default = exports["default"] = setAttendeeNetworkHealth;